export const LOGGER_MESSAGES = {
    PV: "ページ表示",
    CLICK_ENTER_ROOM: "入室ボタン押下",
    CHECK_LESSON_INFO: "レッスン情報確認"
} as const